import { render, staticRenderFns } from "./SecondLevelUpgrade.vue?vue&type=template&id=62c48abc&scoped=true"
import script from "./SecondLevelUpgrade.vue?vue&type=script&lang=js"
export * from "./SecondLevelUpgrade.vue?vue&type=script&lang=js"
import style0 from "./SecondLevelUpgrade.vue?vue&type=style&index=0&id=62c48abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c48abc",
  null
  
)

export default component.exports